import { render, staticRenderFns } from "./RisingStarIcon.vue?vue&type=template&id=43a04ba2&"
import script from "./RisingStarIcon.vue?vue&type=script&lang=js&"
export * from "./RisingStarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports